/**
 * Class-name composition.
 *
 *   cn("btn", isActive && "btn-active", className)
 *
 * No `clsx`, no `cva`, no `tailwind-merge`. Variants in this codebase are
 * string-union props resolved through a lookup map inside the component, which
 * means there is never a "last conflicting utility wins" problem to solve - and
 * that is the only thing tailwind-merge buys. Twelve lines beat three
 * dependencies here.
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
